import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import logosmall from "../assets/images/logosmall.png";
import apiFunctions from "../services/api-service";

const TermsConditionPublicPage: React.FC = () => {
    const navigate = useNavigate();
    const initialized = useRef(false);
    const [content, setContent] = useState("");
    const [gujaratiContent, setGujaratiContent] = useState("");
    const [lang, setLang] = useState<"en" | "gu">("en");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            apiFunctions
                .get("/cmspages/webapp/TermsAndConditions")
                .then((response) => {
                    if (response?.data?.success && response.data.data) {
                        setContent(response.data.data.content || "");
                        setGujaratiContent(response.data.data.gujaraticontent || "");
                    }
                })
                .finally(() => setLoading(false));
        }
    }, []);

    const displayContent = lang === "gu" ? gujaratiContent : content;

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <nav className="bg-white shadow-md p-4 sticky top-0 z-10">
                <div className="max-w-5xl mx-auto flex items-center justify-between">
                    <div
                        className="flex items-center gap-2 cursor-pointer"
                        onClick={() => navigate("/")}
                    >
                        <img src={logosmall} alt="Sagar Samaj" className="h-9 w-9" />
                        <span className="font-semibold text-gray-800">Sagar Samaj</span>
                    </div>
                    <div className="flex gap-2">
                        <button
                            onClick={() => setLang("en")}
                            className={`px-3 py-1 rounded text-sm font-medium border transition cursor-pointer ${lang === "en" ? "bg-blue-600 text-white border-blue-600" : "bg-white text-gray-600 border-gray-300 hover:border-blue-400"}`}
                        >
                            English
                        </button>
                        <button
                            onClick={() => setLang("gu")}
                            className={`px-3 py-1 rounded text-sm font-medium border transition cursor-pointer ${lang === "gu" ? "bg-blue-600 text-white border-blue-600" : "bg-white text-gray-600 border-gray-300 hover:border-blue-400"}`}
                        >
                            ગુજરાતી
                        </button>
                    </div>
                </div>
            </nav>

            <main className="flex-1 max-w-5xl mx-auto w-full px-4 py-10">
                <h1 className="text-3xl font-bold text-gray-800 mb-6 border-b pb-4">
                    {lang === "gu" ? "નિયમો અને શરતો" : "Terms & Conditions"}
                </h1>

                {loading ? (
                    <div className="space-y-3">
                        {[...Array(6)].map((_, i) => (
                            <div key={i} className="h-4 bg-gray-200 rounded animate-pulse" style={{ width: `${80 + (i % 3) * 10}%` }} />
                        ))}
                    </div>
                ) : displayContent ? (
                    <div
                        className="prose prose-gray max-w-none text-gray-700 leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: displayContent }}
                    />
                ) : (
                    <p className="text-gray-500">
                        {lang === "gu" ? "કોઈ સામગ્રી ઉપલબ્ધ નથી." : "No content available."}
                    </p>
                )}
            </main>

            <footer className="bg-gray-800 text-gray-400 py-5 text-center text-sm">
                <p>© {new Date().getFullYear()} Sagar Samaj. All rights reserved.</p>
                <div className="flex justify-center gap-4 mt-2">
                    <span
                        className="cursor-pointer hover:text-white transition"
                        onClick={() => navigate("/privacypolicy")}
                    >
                        Privacy Policy
                    </span>
                    <span className="text-gray-600">|</span>
                    <span
                        className="cursor-pointer hover:text-white transition"
                        onClick={() => navigate("/termsandcondition")}
                    >
                        Terms & Conditions
                    </span>
                </div>
            </footer>
        </div>
    );
};

export default TermsConditionPublicPage;
